// extracted by mini-css-extract-plugin
export default {"msgM":"c68d19a787"};